import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
	root: {
		width: 24,
		height: 24,
		// backgroundColor: '#BCBBD0',

		'& > svg': {
			// margin: theme.spacing(2),
			// width: 24,
			// height: 24,
		},
	},
}));

function VideoIcon(props) {
	return (
		<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M4 18.1504V5.89249C4 3.65312 6.36462 2.20318 8.36049 3.21872L19.2421 8.75556C21.3281 9.81695 21.4494 12.7518 19.4581 13.9817L8.57648 20.7028C6.57781 21.9372 4 20.4995 4 18.1504Z" fill={props.fill} />
		</svg>
	);
}

export default function SvgIconsColor(props) {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<VideoIcon fill={props.fill} />
		</div>
	);
}